exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".galaxy\\:\\:common-canvas-editor-canvas-PageOverlay[data-v-5e05f212]{font-family:Rubik,sans-serif!important;font-weight:400}.galaxy\\:\\:common-canvas-editor-canvas-PageOverlay>*[data-v-5e05f212]{z-index:60}", ""]);

